import moment from 'moment';
import { TransactionDetails } from './transaction.schemas';

export const getProductDescription = (transaction: TransactionDetails) => {
  const {
    productName,
    hostApplication,
    category,
    upgradeOrDowngrade,
    platform,
  } = transaction;
  let name = `${productName} `;
  let productPlatform = '';
  if (platform) {
    productPlatform = `on ${platform}`;
  }
  if (upgradeOrDowngrade) {
    name = `${upgradeOrDowngrade} ${productName ? `for ${productName} ` : ''}`;
  }
  // without host app
  if (!hostApplication) {
    return name + productPlatform;
  }
  // with host app
  const { displayName, version } = hostApplication;
  const productHostApp = `for ${displayName} `;
  let productVersion = '';
  if (category !== 'Subscription') {
    productVersion = `${version} `;
  }
  return name + productVersion + productHostApp + productPlatform;
};
export const transformTransactionToInvoice = (
  transactions: TransactionDetails[],
) => {
  const first = transactions[0];
  return {
    id: first.cartId ?? first._id,
    orderDate: moment(first.createdAt).format('MM/DD/YYYY'),
    customer: {
      name: `${first.firstName} ${first.lastName}`,
      deliveryAddress: first.embeddedPaymentMethod?.billingAddress
        ? {
            street: first.embeddedPaymentMethod.billingAddress.streetAddress,
            city: first.embeddedPaymentMethod.billingAddress.locality,
            state: first.embeddedPaymentMethod.billingAddress.region,
            zip: first.embeddedPaymentMethod.billingAddress.postalCode,
            country: first.embeddedPaymentMethod.billingAddress.countryName,
          }
        : undefined,
      billingAddress: first.embeddedPaymentMethod?.billingAddress
        ? {
            street: first.embeddedPaymentMethod.billingAddress.streetAddress,
            city: first.embeddedPaymentMethod.billingAddress.locality,
            state: first.embeddedPaymentMethod.billingAddress.region,
            zip: first.embeddedPaymentMethod.billingAddress.postalCode,
            country: first.embeddedPaymentMethod.billingAddress.countryName,
          }
        : undefined,
    },
    items: transactions.map((t) => ({
      description: getProductDescription(t),
      unitPrice: t.fullPrice,
      quantity: t.quantity,
      total: t.amount,
      serials: t.serials,
    })),
    upgradeOrDowngrade: first.upgradeOrDowngrade,
    subtotal: transactions.reduce((sum, t) => sum + (t.amount ?? 0), 0),
    total: transactions.reduce((sum, t) => sum + (t.amount ?? 0), 0),
    discountAmount: first.prices?.discountDetails?.amount ?? undefined,
    discountCode: first.prices?.discountDetails?.code ?? undefined,
    paymentMethod: first.embeddedPaymentMethod?.cardType,
    carrier: 'Electronic Delivery',
    serialKey: transactions.flatMap((t) => t.serials).join(','),
  };
};

export type InvoiceDetails = ReturnType<typeof transformTransactionToInvoice>;
